/*
 *  I07CALCPUISSRADI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 19:37:20 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I07CALCPUISSRAD_SECTION_0_TITLE: "Calculez ou convertissez la puissance de vos radiateurs en fonction de leurs tailles et régime d'eau",
  I07CALCPUISSRAD_in_acierFonteIndex: 'Type de radiateur',
  I07CALCPUISSRAD_in_acierFonteIndex_0: 'Acier',
  I07CALCPUISSRAD_in_acierFonteIndex_1: 'Fonte',
  I07CALCPUISSRAD_in_acierFonteIndex_2: 'Aluminium',
  I07CALCPUISSRAD_in_profondeurRadiateur: 'Profondeur du radiateur',
  I07CALCPUISSRAD_typeRadiateur_uuid: 'Type de radiateur',
  I07CALCPUISSRAD_in_hauteurRadiateur: 'Hauteur du radiateur ',
  I07CALCPUISSRAD_in_longeurRadiateur: 'Longueur du radiateur',
  I07CALCPUISSRAD_regimeDimensionnemnt_uuid: 'Régime de température',
  I07CALCPUISSRAD_in_tempConsInt: 'Temp. int de consigne',
  I07CALCPUISSRAD_SECTION_1_TITLE: '',
  I07CALCPUISSRAD_res_puissanceNominale: 'Puissance Nominale',
  I07CALCPUISSRAD_in_nombreElement: "Nombre d'éléments"
}
